import React from 'react';
import { Chip, type ChipProps } from '@mui/material';
import type { EventDatasetStatus } from '../../../../types/backend';

type DatasetState = EventDatasetStatus['state'];

const STATE_CONFIG: Record<DatasetState, { label: string; color: ChipProps['color'] }> = {
  current: { label: 'Current', color: 'success' },
  backfilling: { label: 'Backfilling', color: 'info' },
  behind: { label: 'Behind', color: 'warning' },
  failing: { label: 'Failing', color: 'error' },
  deleting: { label: 'Deleting', color: 'default' },
};

interface DatasetStateBadgeProps {
  state: DatasetState | undefined;
  loading: boolean;
  error: string | null;
}

// The error branch comes first: a status that could not be read never shows as a known state (FE-14).
const DatasetStateBadge: React.FC<DatasetStateBadgeProps> = ({ state, loading, error }) => {
  if (error) {
    return <Chip size="small" color="error" variant="outlined" label="Could not read status" title={error} />;
  }
  if (loading || !state) {
    return <Chip size="small" variant="outlined" label="Reading status" />;
  }
  const config = STATE_CONFIG[state];
  return <Chip size="small" color={config.color} label={config.label} />;
};

export default DatasetStateBadge;
